import { render, staticRenderFns } from "./uploadAttachments.vue?vue&type=template&id=175d7982&scoped=true&"
import script from "./uploadAttachments.vue?vue&type=script&lang=js&"
export * from "./uploadAttachments.vue?vue&type=script&lang=js&"
import style0 from "./uploadAttachments.vue?vue&type=style&index=0&id=175d7982&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "175d7982",
  null
  
)

export default component.exports